import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

import { Link } from "react-router-dom";
import { useContext } from "react";
import { RoleContext } from "../RoleContext";
import Table from "./../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Badge from "@mui/material/Badge";
import Spinner from "../Spinner";
import { Button } from "react-bootstrap";
import { handleExportClick } from "../exportFile.js";
import { Checkbox, Modal } from "antd";
import ReactToPrint from "react-to-print";
import BookedTrips from "../reports/BookedTrips";

import ActionButtons from "./TripsActionButton.js";




import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { 
  Visibility as VisibilityIcon
} from '@mui/icons-material';
import {  useNavigate } from 'react-router-dom';


const ReservationsList = () => {
  const roleData = useContext(RoleContext);
  var role = JSON.parse(roleData);
  let [loading, setLoading] = useState(true);
  const [reservations, setReservations] = useState([]);
  const getReservations = async () => {
    const userType = typeof window !== 'undefined' ? localStorage.getItem('userType') : null;
    const isCompanyUser = userType === 'ambulance_company';
    const url = isCompanyUser ? "companyReservations/" : "reservations/";
    const response = await axios
      .get(url)
      .then((res) => {
        const newRes = res.data.map((re) => {
          return {
            ...re,
            passenger: {
              ...re.passenger,
              name: re.passenger.firstName + " " + re.passenger.lastName,
            },
          };
        });
        setReservations(newRes);
        setLoading(false);
        //notify()
      })
      .catch((err) => {
        notifyError();
      });
  };
  const edit = "reservation";
  const detail = "viewReservation";

  const notify = () =>
    toast.success("Reservations list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  useEffect(() => {
    getReservations();
  }, []);
  

const navigate = useNavigate();
const columns = React.useMemo(
  () => [
    {
      Header: "Passenger Information",
      columns: [
        {
          Header: "ID",
          accessor: "id",
        },
        {
          Header: "First Name",
          accessor: "passenger.firstName",
        },
        {
          Header: "Last Name",
          accessor: "passenger.lastName",
        },
        {
          Header: "Phone Number",
          accessor: "passenger.phoneNumber",
        },
      ],
    },
    {
      Header: "Location Information",
      columns: [
        {
          Header: "Pick Up Location Latitude",
          accessor: "pickUpLocationLatitude",
        },
        {
          Header: "Pick Up Location Longitude",
          accessor: "pickUpLocationLongitude",
        },
        {
          Header: "Destination Location Lat",
          accessor: "destinationLocationLatitude",
        },
        {
          Header: "Destination Location Long",
          accessor: "destinationLocationLongitude",
        },
        {
          Header: "Status",
          accessor: "status",
          disableFilters: true,
          Cell: (row) => {
            const status = row.cell.row.original.status || "Active";
            return (
              <Chip 
                label={status} 
                color={status === "Active" ? "success" : "warning"}
                variant="filled"
                sx={{
                  fontWeight: 'bold',
                  borderRadius: '8px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  boxShadow: status === "Active" 
                    ? '0 2px 4px rgba(0,255,0,0.2)' 
                    : '0 2px 4px rgba(255,165,0,0.2)'
                }}
              />
            );
          },
        },
        {
          Header: "Action",
          accessor: "action",
          disableFilters: true,
          Cell: (row) => (
            <div style={{ 
              display: "flex", 
              gap: "15px", 
              alignItems: 'center' 
            }}>
              {role.filter(e => e.perm_name === "list_booked_trips").length > 0 && (
                <Tooltip title="View Reservation Details">
                  <span>
                    <VisibilityIcon 
                      color="success" 
                      sx={{ 
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                        '&:hover': {
                          transform: 'scale(1.2)',
                          color: '#16a34a'
                        }
                      }}
                      onClick={() => navigate(`/reservation/${row.cell.row.original.id}`)}
                    />
                  </span>
                </Tooltip>
              )}
            </div>
          ),
        },
      ],
    },
  ],
  []
);

  const columns_expo = React.useMemo(
    () =>
      [
        {
          columns: [
            {
              Header: "Id",
              accessor: "id",
            },
          ],
        },
        {
          Header: "Passenger",
          columns: [
            { Header: "Passenger Name", accessor: "passenger.name" },
            // { Header: "Last Name", accessor: "passenger.lastName" },
            { Header: "Passenger Phone", accessor: "passenger.phoneNumber" },
          ],
        },
        {
          Header: "Location Information",
          columns: [
            {
              Header: "PickUp Lat",
              accessor: "pickUpLocationLatitude",
            },
            {
              Header: "PickUp Long",
              accessor: "pickUpLocationLongitude",
            },
            {
              Header: "Destination Location Lat",
              accessor: "destinationLocationLatitude",
            },
            {
              Header: "Destination Location Long",
              accessor: "destinationLocationLongitude",
            },

            ,
            {
              Header: "Status",
              accessor: "status",
            },
          ],
        },
      ].flatMap((group) => group.columns),
    []
  );

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const [selectedColumns, setSelectedColumns] = useState(
    columns_expo.map((column) => column.Header)
  );

  const handleOkModal = () => {
    console.log("handleOkModal called");
    setIsModalVisible(false);
    handleExportClick(
      reservations,
      columns_expo,
      "Reservations",
      "reservations.pdf",
      selectedColumns
    );
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // Inside your component
  function handleColumnToggle(columnHeader) {
    setSelectedColumns((prevSelectedColumns) => {
      if (prevSelectedColumns.includes(columnHeader)) {
        return prevSelectedColumns.filter((col) => col !== columnHeader);
      } else {
        return [...prevSelectedColumns, columnHeader];
      }
    });
  }

  const prRef = useRef(null);
  const [isPrintableComponentVisible, setIsPrintableComponentVisible] =
    useState(false);

  const handlePrintButtonClick = () => {
    setIsPrintableComponentVisible(true);
  };
  return (
    <div className="content-wrappers" style={{ marginTop: '-40px' }}>
    <div className="content-wrappers">
      <br />
      <br />
      <ToastContainer />

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                  <ActionButtons title="Reservations"  showModal={showModal}/>
                  <Modal
                   style={{marginTop: "60px"}} 
                    title="Select Columns to Export"
                    visible={isModalVisible}
                    onOk={handleOkModal}
                    onCancel={handleCancel}
                    footer={[
                      <Button key="cancel" onClick={handleCancel}>
                        Cancel
                      </Button>,
                      <Button
                        style={{ marginLeft: "10px" }}
                        key="ok"
                        type="primary"
                        onClick={handleOkModal}
                      >
                        OK
                      </Button>
                    ]}
                  >
                    <div style={{ marginBottom: "20px" }}>
                      {columns_expo.map((column) => (
                        <div
                          key={column.Header}
                          style={{ marginBottom: "10px" }}
                        >
                          <Checkbox
                            checked={selectedColumns.includes(column.Header)}
                            onChange={() => handleColumnToggle(column.Header)}
                            style={{ marginRight: "10px", fontSize: "16px" }}
                          >
                            {column.Header}
                          </Checkbox>
                        </div>
                      ))}
                    </div>
                  </Modal>
                <div className="card-body">
                  {loading && (
                    <div>
                      <Spinner />
                    </div>
                  )}
                  {!loading && (
                    <Table
                      columns={columns}
                      data={reservations}
                      edit={edit}
                      detail={detail}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </div>
  );
};

export default ReservationsList;
